module.exports = __webpack_public_path__ + "img/canvasMenu2.cea0b487.svg";